<template>
  <form-group label="Status do produto" :columns="6">
    <select v-model="filters.status" class="form-select">
      <option :value=null>Todos</option>
      <option v-for="status in productStatuses" :value="status" :key="status">{{ $t(status).label }}</option>
    </select>
  </form-group>
</template>

<script>
  import api from '@/api'
  import FormGroup from '@/components/template/FormGroup'

  export default {
    data: () => ({
      productStatuses: [],
      filters: {
        status: null
      }
    }),
    props: {
      module: {
        type: Object,
        required: true
      }
    },
    mounted () {
      api.getProductStatuses(this.module.type, this.module.identifier)
        .then(productStatuses => {
          this.productStatuses = productStatuses
          let index = this.productStatuses.indexOf('queue')

          if (index !== -1) {
            this.productStatuses.splice(index, 1)
          }
        })
        .catch(() => (this.productStatuses = []))
    },
    watch: {
      'filters.status' () {
        this.$emit('change', this.filters)
      }
    },
    components: {
      FormGroup
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ProductStatus.vue?e5b0fd8e